"use strict";

// Required for Theme Addresses
// import 'element-matches';

/*================ Theme Scripts ================*/
// import * as a11y from '@shopify/theme-a11y';
// import * as currency from '@shopify/theme-currency';
// import {AddressForm} from '@shopify/theme-addresses';
// import * as sections from '@shopify/theme-sections';

/*================ Global Functions ================*/

window.serializeForm = form => {
    const obj = {};
    const formData = new FormData(form);
    for (const key of formData.keys()) {
      obj[key] = formData.get(key);
    }
    return JSON.stringify(obj);
};
  
window.fetchConfig = function (type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
}

window.debounce = function (callback, wait) {
    let timeout;
    return (...args) => {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => callback.apply(context, args), wait);
    };
};

window.Events = function (){
    return {
        itemAdded: {
            name: "theme:itemAdded",
            _event: (cart) => {
                console.log('theme:itemAdded');
                return new CustomEvent("theme:itemAdded", {
                    bubbles: true,
                    detail: {
                        cart: cart
                    }
                });
            }
        },
        itemUpdated: {
            name: "theme:itemUpdated",
            _event: (product) => {
                return new CustomEvent("theme:itemUpdated", {
                    bubbles: true,
                    detail: {
                        product: product
                    }
                });
            }
        },
        itemRemoved: {
            name: "theme:itemRemoved",
            _event: (product) => {
                return new CustomEvent("theme:itemRemoved", {
                    bubbles: true,
                    detail: {
                        product: product
                    }
                });
            }
        },
        cartUpdated: {
            name: "theme:cartUpdated",
            _event: (cart) => {
                return new CustomEvent("theme:cartUpdated", {
                    bubbles: true,
                    detail: {
                        cart: cart
                    }
                });
            }
        },
        formUpdated: {
            name: "theme:formUpdated",
            _event: (form) => {
                return new CustomEvent("theme:formUpdated", {
                    bubbles: true,
                    detail: {
                        form: form
                    }
                });
            }
        }
    }
};

/*
 * Helper to set a cookie.
 *
 * @param cname: Name of the cookie.
 * @param cvalue: Value of the cookie.
 * @param exdays: Days until the cookie expires.
 */
window.setCookie = function (cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
  
/*
 * Helper to get a cookie.
 *
 * @param cname: Name of the cookie.
 */
window.getCookie = function (cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

/*
 * Helper to check if a cookie exists.
 *
 * @param cname: Name of the cookie.
 */
window.hasCookie = function (cname) {
    let cookie = getCookie(cname);
    if (cookie != "") {
        return true;
    } else {
        return false;
    }
}

/*================ Theme Functions ================*/
class Theme {

    constructor() {

        // Define the cart objects
        // this.cart = window.theme.cart;

        // Cache objects
        // this.currencySelect = document.querySelectorAll('select[name="currency"]');
        this.cartCount = document.querySelectorAll('[data-cart-count]') || false;
    }
  
    /*
     * The Initializer
     */
    init() {
  
      this.listeners();
    }
  
    /*
     * The Listeners
     */
    listeners() {
  
        document.addEventListener(Events().cartUpdated.name, this.cartUpdated.bind(this));
    }

    /*
     * Cart updated callback
     */
    cartUpdated() {

        // console.log(event.detail.cart);

        if( this.cartCount !== false ){

            this.cartCount.forEach(cartCount => {
                cartCount.innerHTML = event.detail.cart.item_count; 
            });
        }
    }
  
    cookiesEnabled() {
    }
  
    /*
     * Currency Select
     *
     * Trigger the currency select form when the select input is changed.
     */
    currencySelect() {
      
      if( typeof this.currencySelect != "undefined" && this.currencySelect.length != 0 ){
        this.currencySelect.forEach((selector)=>{
  
          selector.addEventListener('change', function (event){
            event.currentTarget.parentElement.submit();
          });
        });      
      }
    }
  
    addressForms() {
  
      AddressForm(document.querySelector('[data-address=root]'), 'en');
    }
}

const theme = new Theme();
theme.init();

// class DrawerTrigger extends HTMLElement{
    
//     constructor(){
//         super();

//         const self = this;

//         this.target = document.querySelector(this.dataset.target);
//         this.blackout = this.target.querySelector('[data-blackout]');
//         this.openClass = this.dataset.openClass;
//         this.closeClass = this.dataset.closeClass;

//         this.addEventListener('click', this.toggleTarget.bind(this));

//         document.addEventListener('keyup', function (e) {
            
//             if (e.key === "Escape") {
//                 self.close();
//             }
//         });

//         if( this.blackout !== undefined && this.blackout !== null ){
//             this.blackout.addEventListener('click', this.close.bind(this));
//         }
//     }

//     open() {

//         event.preventDefault();

//         document.querySelector('body').classList.add('overflow-hidden');
            
//         this.target.classList.add(this.openClass);
//         this.blackout.classList.add(this.openClass);
//         this.target.classList.remove(this.closeClass);
//         this.blackout.classList.remove(this.closeClass);
//     }

//     close() {

//         event.preventDefault();
        
//         document.querySelector('body').classList.remove('overflow-hidden');

//         this.target.classList.remove(this.openClass);
//         this.blackout.classList.remove(this.openClass);
//         this.target.classList.add(this.closeClass);
//         this.blackout.classList.add(this.closeClass);
//     }

//     toggleTarget() {

//         // Target is open
//         if( this.target.classList.contains(this.openClass) ){
//             this.close();
//         }else{
//             this.open();
//         }
//     }
// }

// customElements.define('drawer-trigger', DrawerTrigger);


// MIT Licensed
// Author: jwilson8767

/**
 * Waits for an element satisfying selector to exist, then resolves promise with the element.
 * Useful for resolving race conditions.
 *
 * @param selector
 * @returns {Promise}
 */
function elementReady(selector) {
  return new Promise((resolve, reject) => {
    let el = document.querySelector(selector);
    if (el) {
      resolve(el); 
      return
    }
    new MutationObserver((mutationRecords, observer) => {
      // Query for elements matching the specified selector
      Array.from(document.querySelectorAll(selector)).forEach((element) => {
        resolve(element);
        //Once we have resolved we don't need the observer anymore.
        observer.disconnect();
      });
    })
      .observe(document.documentElement, {
        childList: true,
        subtree: true
      });
  });
}